import { render, staticRenderFns } from "./PendingTrash.vue?vue&type=template&id=4624d744"
import script from "./PendingTrash.vue?vue&type=script&lang=js"
export * from "./PendingTrash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports